import { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';

import { useTheme } from '../../Context/ThemeContext';
import { useLanguage } from '../../Context/LanguageContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

import SelectOnPath from '../../image/SelectOn2.png';
import SelectOffPath from '../../image/SelectOff2.png';
import WhiteTrashIcon from '../../image/WhiteTrashIcon.png';

export default function PaymentOptionSettingSelectBox(props) {
  const {
    index,
    value,
    setValue,
    options,
    disabled,
    width,
    onClickAdditionOption,
    onClickDeleteOption
  } = props;

  const { isDark } = useTheme();
  const { t } = useLanguage();
  const theme = isDark ? darkTheme : lightTheme;

  const PAYMENT_NAME_MAP = {
    '현금': t('paymentSelectBox.cash'),
    '카드': t('paymentSelectBox.card'),
    '포인트': t('paymentSelectBox.point'),
  };

  function getDisplayName(name) {
    return PAYMENT_NAME_MAP[name] ?? name;
  }

  const [isClicked, setIsClicked] = useState(false);
  const [isAdditionButtonHover, setIsAddionButtonHover] = useState(false);

  const TopLevelRef = useRef();
  const SelectRef = useRef();
  const OptionRef = useRef([]);
  const OptionTextRef = useRef([]);


  // 컴포넌트 외부 클릭시 이벤트를 받기위한 리스너 연결
  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [])

  // 컴포넌트 외부 클릭시 실행
  function onClickOutSide(e) {
    if (TopLevelRef.current !== e.target && !TopLevelRef.current.contains(e.target)) {
      SelectRef.current.style.border = `1px solid ${theme.line}`;
      SelectRef.current.style.height = `30px`;
      SelectRef.current.style.overflow = 'hidden';

      setTimeout(() => (
        setIsClicked(false)
      ), 150)
    }
  }

  // 옵션 호버링 시작 //
  function onMouseOver(index) {
    OptionRef.current[index] && (OptionRef.current[index].style.backgroundColor = theme.primary);
    OptionTextRef.current[index] && (OptionTextRef.current[index].style.color = theme.white);
  }

  // 옵션 호버링 끝 //
  function onMouseLeave(index) {
    OptionRef.current[index] && (OptionRef.current[index].style.backgroundColor = theme.subBackground);
    OptionTextRef.current[index] && (OptionTextRef.current[index].style.color = theme.text);
  }

  // 선택박스 클릭시 //
  function onClick() {
    if (disabled) return;
    else if (!options[0]) return;

    if (isClicked) {
      SelectRef.current.style.border = `1px solid ${theme.line}`;
      SelectRef.current.style.height = `30px`;
      SelectRef.current.style.overflow = 'hidden';

      setTimeout(() => (
        setIsClicked(false)
      ), 150)
    }
    else {
      SelectRef.current.style.border = `1px solid ${theme.primary}`;
      SelectRef.current.style.height = `${32 * (options.length + 2)}px`;
      SelectRef.current.style.maxHeight = '160px';
      SelectRef.current.style.overflowY = 'scroll';
      SelectRef.current.style.overflowX = 'none';
      setIsClicked(true);
    }
  }

  // 옵션 클릭시 //
  function optionalClick(optionIndex) {
    setValue(options[optionIndex], index);
  }

  // 옵션 추가 클릭시 //
  function onClickAdditionOptionButton() {
    onClickAdditionOption();
  }

  return (
    <TopLevelWrapper
      ref={TopLevelRef}
      width={width}>
      <SelectBox
        ref={SelectRef}
        isClicked={isClicked}
        buttonPath={isClicked ? SelectOnPath : SelectOffPath}
        width={width}
        onClick={onClick}>
        <SelectedViewWrapper width={width}>
          <SelectedViewTextWrapper>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='pointer'>{getDisplayName(value.name)}</Text>
          </SelectedViewTextWrapper>
          <ArrowImageWrapper>
            <ArrowImage src={SelectOnPath} opacity={isClicked ? 1 : 0} />
            <ArrowImage src={SelectOffPath} opacity={isClicked ? 0 : 1} />
          </ArrowImageWrapper>
        </SelectedViewWrapper>
        {
          isClicked &&
          options.map((optionData, optionIndex) =>
            <OptionWrapper
              key={'PaymentOptions-' + optionIndex}
              ref={(element) => OptionRef.current[optionIndex] = element}
              onMouseOver={() => onMouseOver(optionIndex)}
              onMouseLeave={() => onMouseLeave(optionIndex)}
              onClick={() => optionalClick(optionIndex)}>
              <OptionTextWrapper>
                <Text ref={(element) => OptionTextRef.current[optionIndex] = element} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='pointer'>{getDisplayName(optionData.name)}</Text>
              </OptionTextWrapper>
              {
                optionData.id !== 0 &&
                <DeleteButton onClick={(e) => {
                  e.stopPropagation();
                  onClickDeleteOption(optionData.id);

                  SelectRef.current.style.border = `1px solid ${theme.line}`;
                  SelectRef.current.style.height = `30px`;
                  SelectRef.current.style.overflow = 'hidden';

                  setTimeout(() => (
                    setIsClicked(false)
                  ), 150)
                }}>
                  <DeleteIcon src={WhiteTrashIcon} />
                </DeleteButton>
              }
            </OptionWrapper>
          )
        }
        {
          isClicked &&
          <AdditionOptionWrapper
            isHover={isAdditionButtonHover}
            onMouseOver={() => setIsAddionButtonHover(true)}
            onMouseLeave={() => setIsAddionButtonHover(false)}
            onClick={onClickAdditionOptionButton}>
            <Text fontFamily='NotoSansKR-Medium' fontSize={12} color={isAdditionButtonHover ? theme.white : theme.text} cursor='pointer'>{t('paymentSelectBox.addPaymentOptionInSelect')}</Text>
          </AdditionOptionWrapper>
        }
      </SelectBox>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
	${props => !props.width && 'position: relative;'}
	display: flex;
	flex-direction: column;

	width: ${props => props.width ? `${props.width}px` : '100%'};
	height: 30px;
`;

const SelectBox = styled.div`
	position: absolute;
	display: flex;
	flex-direction: column;

	justify-content: flex-start;
	align-items: flex-start;

	width: ${props => props.width ? `${props.width}px` : '100%'};
	height: 30px;

	border-radius: 5px;
	overflow: hidden;

  border: 1px solid ${props => props.theme.line};
  box-sizing: border-box;
	background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

	&:hover {
		cursor: pointer;
	}

	&::-webkit-scrollbar {
		// width: 9px;
    width: 0px;
	}

	&::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px ${props => props.theme.primary};
		border: 3px solid transparent;
		height: 25px;
		border-radius: 200px;
	}

	&::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px 10px transparent;
		border: 4px solid transparent;
		background-color: transparent;
	}

	&::-webkit-scrollbar-track-piece {
		background-color: transparent;
	}
`;

const SelectedViewWrapper = styled.div`
  display: flex;
  flex-direction: row;

	justify-content: space-between;
	align-items: center;

  padding: 3px 8px;

  width: ${props => props.width ? `calc(${props.width}px - 17px)` : 'calc(100% - 17px)'};

  border-bottom: 1px solid ${props => props.theme.line};
`;

const SelectedViewTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

	justify-content: flex-start;
	align-items: flex-start;

  width: 100%;
  height: 20px;
  
  overflow: hidden;
`;

const ArrowImageWrapper = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;

	justify-content: center;
	align-items: center;

  margin: 7px 0px;
  
  width: 16px;
  height: 10px;
`;

const ArrowImage = styled.img`
	position: absolute;

  width: 100%;
  height: 100%;

  opacity: ${props => props.opacity};

  transition: all 0.3s ease-in-out;
`;

const OptionWrapper = styled.div`
	display: flex;
	flex-direction: row;

	justify-content: space-between;
	align-items: center;

  padding: 6px 8px;

	width: calc(100% - 17px);

  border-bottom: 1px solid ${props => props.theme.line};

	&:hover {
		cursor: pointer;
	}

  transition: all 0.3s ease-in-out;
`;

const OptionTextWrapper = styled.div`
	display: flex;
	flex-direction: row;

	justify-content: flex-start;
	align-items: flex-start;

	width: 80%;
  height: 20px;

  overflow: hidden;
`;

const AdditionOptionWrapper = styled.div`
	display: flex;
	flex-direction: column;

	justify-content: center;
	align-items: center;

  padding: 6px 8px;

	width: calc(100% - 17px);

  background-color: ${props => props.isHover ? props.theme.primary : props.theme.subBackground};

	&:hover {
		cursor: pointer;
	}
    
  transition: all 0.3s ease-in-out;
`;

const DeleteButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 24px;
  height: 18px;

  border-radius: 2px;
  background-color: ${props => props.theme.pointRedAlpha50};

  &:hover {
    cursor: pointer;
    background-color: ${props => props.theme.pointRed};
  }

  transition: all 0.3s ease-in-out;
`;

const DeleteIcon = styled.img`
  width: 14px;
  height: 14px;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0px;

  &:hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;